import React from "react";
import { ResultsContainer } from "./PageResultsTab";
import DefaultContent from "../common/Content";
import styled from "styled-components";
import DefaultHeadline from "../common/Headline";
import Button from "../common/Button";
import { Router, RouteParams } from "../../lib/routes";
import { SEARCH_INPUT_ID } from "./AutocompleteSearchInput";
import { bottomMargins } from "../theme";

const Content = styled(DefaultContent)`
  text-align: center;
  height: 100%;
  justify-content: center;
`;

const Headline = styled(DefaultHeadline)`
  ${bottomMargins.smallPlusPlus}
`;
const MagnifyingGlass = styled.img`
  width: 150px;
  height: 150px;
  margin: auto;
  object-fit: contain;
  ${bottomMargins.smallPlusPlus}
`;

export const EmptyResultInfo =
  "Wir können zu diesem Suchbegriff leider nichts finden...";

export default function EmptyResultsTab() {
  const resetSearch = () => {
    const { q, page, ...query } = Router.query;
    Router.replaceRoute(Router.route.replace("/", ""), query as RouteParams);
    document.getElementById(SEARCH_INPUT_ID).focus();
  };
  return (
    <ResultsContainer>
      <Content padded>
        <MagnifyingGlass src="/static/assets/magnifyingGlass.svg" alt="" />
        <Headline size={4} level={2}>
          {EmptyResultInfo}
        </Headline>
        <div>
          <Button small ghost onclick={() => resetSearch()}>
            Neue Suche starten
          </Button>
        </div>
      </Content>
    </ResultsContainer>
  );
}
